import styled, { css } from "styled-components";
import {
  CARTAZ_GRANDE,
  CARTAZ_MEDIO,
  CARTAZ_PEQUENO,
} from "../EncarteConstants";

const PADDING_BY_SIZE = {
  [CARTAZ_GRANDE]: 14,
  [CARTAZ_MEDIO]: 20,
  [CARTAZ_PEQUENO]: 30,
};

const DEFAULT_NAME_FONT_SIZE_BY_SIZE = {
  [CARTAZ_GRANDE]: 100,
  [CARTAZ_MEDIO]: 50,
  [CARTAZ_PEQUENO]: 35,
};
export const Name = styled.p`
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  color: #111111;
  font-size: ${({ styles, canvasScale }) =>
    DEFAULT_NAME_FONT_SIZE_BY_SIZE[styles.format] * canvasScale}px;
  margin-bottom: ${({ canvasScale }) => 8 * canvasScale}px;
  padding: 0 10%;
  line-height: 1;
  font-style: italic;
`;

export const ProductContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;
  ${({ canvasScale, styles }) => {
    return `
    background-color: #ffffff;

    padding: ${PADDING_BY_SIZE[styles.format] * canvasScale}px;
    gap: ${30 * canvasScale}px;
  `;
  }}
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-content: center;
`;

export const Measurement = styled.span`
  font-size: ${({ canvasScale }) => 35 * canvasScale}px;
  color: #111111;
  text-align: center;
  text-transform: uppercase;
`;
